/**
 * @deprecated This module is deprecated and will be removed in future versions.
 */

import { getInstance } from '../app/app.module';
import { CartController } from './cart.controller';
import type { AddToCartResult } from './cart.model';
import { CartSelectors } from './cart.selectors';

export const addToCart = async (
  _context: unknown,
  ...params: Parameters<CartController['addToCart']>
): Promise<AddToCartResult | undefined> => {
  const cartController = getInstance(CartController);

  return cartController?.addToCart(...params);
};

export const getCartSelectorAndUpdateAction = ():
  | ReturnType<CartSelectors['getCartSelectorAndUpdateAction']>
  | undefined => {
  const cartSelectors = getInstance(CartSelectors);

  return cartSelectors?.getCartSelectorAndUpdateAction();
};
